const PRE_START = 4 * 60
const REGULAR_START = 9 * 60 + 30
const REGULAR_END = 16 * 60
const AFTER_END = 20 * 60

export function getEasternTimeParts(date = new Date()) {
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    weekday: 'short',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
    hourCycle: 'h23'
  })
  const valueMap = {}
  formatter.formatToParts(date).forEach(part => {
    if (part.type !== 'literal') {
      valueMap[part.type] = part.value
    }
  })
  const weekdayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }
  const hours = Number(valueMap.hour || 0)
  const minutes = Number(valueMap.minute || 0)
  const seconds = Number(valueMap.second || 0)
  return {
    weekday: weekdayMap[valueMap.weekday] != null ? weekdayMap[valueMap.weekday] : 0,
    hours,
    minutes,
    seconds,
    totalMinutes: hours * 60 + minutes
  }
}

export function getUsMarketState(date = new Date()) {
  const et = getEasternTimeParts(date)
  const { weekday, totalMinutes } = et
  let marketSession = 'CLOSED'
  let nextSessionLabel = '夜盘交易'
  let minutesToNextSession = 0
  let recommendedSessionType = 'OVERNIGHT'

  if (weekday >= 1 && weekday <= 4) {
    if (totalMinutes < PRE_START) {
      marketSession = 'OVERNIGHT'
      nextSessionLabel = '盘前交易'
      minutesToNextSession = PRE_START - totalMinutes
      recommendedSessionType = 'OVERNIGHT'
    } else if (totalMinutes < REGULAR_START) {
      marketSession = 'PRE_MARKET'
      nextSessionLabel = '常规交易'
      minutesToNextSession = REGULAR_START - totalMinutes
      recommendedSessionType = 'PRE'
    } else if (totalMinutes < REGULAR_END) {
      marketSession = 'REGULAR'
      nextSessionLabel = '盘后交易'
      minutesToNextSession = REGULAR_END - totalMinutes
      recommendedSessionType = 'REGULAR'
    } else if (totalMinutes < AFTER_END) {
      marketSession = 'AFTER_HOURS'
      nextSessionLabel = '夜盘交易'
      minutesToNextSession = AFTER_END - totalMinutes
      recommendedSessionType = 'POST'
    } else {
      marketSession = 'OVERNIGHT'
      nextSessionLabel = '盘前交易'
      minutesToNextSession = 24 * 60 - totalMinutes + PRE_START
      recommendedSessionType = 'OVERNIGHT'
    }
  } else if (weekday === 5) {
    if (totalMinutes < PRE_START) {
      marketSession = 'OVERNIGHT'
      nextSessionLabel = '盘前交易'
      minutesToNextSession = PRE_START - totalMinutes
      recommendedSessionType = 'OVERNIGHT'
    } else if (totalMinutes < REGULAR_START) {
      marketSession = 'PRE_MARKET'
      nextSessionLabel = '常规交易'
      minutesToNextSession = REGULAR_START - totalMinutes
      recommendedSessionType = 'PRE'
    } else if (totalMinutes < REGULAR_END) {
      marketSession = 'REGULAR'
      nextSessionLabel = '盘后交易'
      minutesToNextSession = REGULAR_END - totalMinutes
      recommendedSessionType = 'REGULAR'
    } else if (totalMinutes < AFTER_END) {
      marketSession = 'AFTER_HOURS'
      nextSessionLabel = '周日夜盘'
      minutesToNextSession = (24 * 60 - totalMinutes) + (24 * 60) + AFTER_END
      recommendedSessionType = 'POST'
    } else {
      marketSession = 'CLOSED'
      nextSessionLabel = '周日夜盘'
      minutesToNextSession = (24 * 60 - totalMinutes) + (24 * 60) + AFTER_END
      recommendedSessionType = 'OVERNIGHT'
    }
  } else if (weekday === 6) {
    marketSession = 'CLOSED'
    nextSessionLabel = '周日夜盘'
    minutesToNextSession = (24 * 60 - totalMinutes) + AFTER_END
    recommendedSessionType = 'OVERNIGHT'
  } else {
    if (totalMinutes < AFTER_END) {
      marketSession = 'CLOSED'
      nextSessionLabel = '夜盘交易'
      minutesToNextSession = AFTER_END - totalMinutes
      recommendedSessionType = 'OVERNIGHT'
    } else {
      marketSession = 'OVERNIGHT'
      nextSessionLabel = '盘前交易'
      minutesToNextSession = 24 * 60 - totalMinutes + PRE_START
      recommendedSessionType = 'OVERNIGHT'
    }
  }

  return {
    ...et,
    marketSession,
    nextSessionLabel,
    minutesToNextSession,
    recommendedSessionType
  }
}

export function formatUsMarketCountdown(totalMinutes) {
  if (!Number.isFinite(totalMinutes) || totalMinutes <= 0) {
    return ''
  }
  const days = Math.floor(totalMinutes / (24 * 60))
  const hours = Math.floor((totalMinutes % (24 * 60)) / 60)
  const minutes = totalMinutes % 60
  const parts = []
  if (days > 0) parts.push(`${days}天`)
  if (hours > 0 || days > 0) parts.push(`${hours}小时`)
  parts.push(`${minutes}分钟`)
  return parts.join('')
}

export function getPreferredUsQuoteSession(date = new Date()) {
  const marketSession = getUsMarketState(date).marketSession
  if (marketSession === 'PRE_MARKET') return 'PRE'
  if (marketSession === 'AFTER_HOURS') return 'POST'
  if (marketSession === 'OVERNIGHT') return 'OVERNIGHT'
  return 'REGULAR'
}

export function isUsRegularMarketOpen(date = new Date()) {
  return getUsMarketState(date).marketSession === 'REGULAR'
}

export function shouldShowUsDailyProfit(date = new Date()) {
  const session = getUsMarketState(date).marketSession
  return session !== 'AFTER_HOURS' && session !== 'CLOSED'
}
